import React, { useState } from 'react';

import {
  SelectWrapper,
  Select,
  SelectDropDown,
  DropDownItem,
  DropDownLink,  
} from './styled-components';

/**
 * @param {array} items - a list of links with title and url
 * @param {string} active - the currently active title
 */
const DropDown = ({ items }) => {
  const [isOpen, setIsOpen] = useState(false);
  const active = items.filter(item => item.active)[0] || items[0];

  const handleClick = (e) => {
    setIsOpen(!isOpen);
  }

  return (<SelectWrapper>
    <Select open={isOpen} onClick={handleClick}>
      <span>
        {active.title}
      </span>
    </Select>
    <SelectDropDown open={isOpen}>
      {items.map(item => {
        return (<DropDownItem active={item.active} key={item.title}>
          <DropDownLink href={item.url}>{item.title}</DropDownLink>
        </DropDownItem>);
      })}
    </SelectDropDown>
  </SelectWrapper>);
}

export default DropDown;